<template>
  <div style="display: flex; align-items: center">
    <el-select v-model="timeName" size="small" placeholder="请选择导出时间类型" style="width: 150px;margin-right: 10px"
      filterable @change="sendSearchData" v-if="option.length > 1">
      <el-option v-for="item in option" :key="item.value" :label="item.label" :value="item.value"></el-option>
    </el-select>
    <el-select v-model="radio" size="small" style="width: 150px;margin-right: 10px"
      filterable @change="sendSearchData">
      <el-option v-for="item in radioOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
    </el-select>
    <div style="margin-right: 10px;margin-left: 10px">
      <el-date-picker size="medium" format="yyyy" value-format="yyyy" v-show="radio === 'year'" v-model="year"
        type="year" style="width: 260px" placeholder="选择年"></el-date-picker>
      <el-date-picker size="medium" format="yyyy-MM" value-format="yyyy-MM" v-show="radio === 'month'" v-model="month"
        type="month" style="width: 260px" placeholder="选择月"></el-date-picker>
      <el-date-picker size="medium" format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="date"
        v-show="radio === 'date'" :unlink-panels="true" style="width: 260px" start-placeholder="开始日期"
        end-placeholder="结束日期" type="daterange" range-separator="-"></el-date-picker>
      <el-date-picker v-model="end" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" size="medium"
        placeholder="选择日期" v-show="radio === 'end'" style="width: 260px">
      </el-date-picker>
    </div>
    <el-button v-if="onlyWay" size="small" type="success" icon="el-icon-upload" @click="exportToExcel('time')">导出</el-button>
    <el-dropdown v-if="!onlyWay"
        @command="(command) => exportToExcel(command)" size="small" style="margin-right: 10px">
      <el-button size="small" type="success">导出<i class="el-icon-arrow-down el-icon--right"></i></el-button>
      <el-dropdown-menu slot="dropdown">
         <el-dropdown-item icon="el-icon-time" command="time">按时间导出</el-dropdown-item>
        <el-dropdown-item icon="el-icon-check" command="ids">勾选数据导出</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-button size="small" type="primary" icon="el-icon-upload" @click="exportAllToExcel()">全部导出</el-button>
  </div>
</template>

<script>

import {fileDownload} from "@/utils/downFileUtils";

export default {
  name: "ExportComponents",
  components: {},
  props: {
    apiFunction: {
      type: Function,
      required: true
    },
    requestData: {
      type: Object,
      default: () => ({})
    },
    option: {
      type: Array,
      default: () => ([])
    },
    ids: {
      type: Array,
      default: () => ([])
    },
    onlyWay:{
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      radio:'date',
      year:'',
      date:[],
      month:'',
      timeName: 'createTime',
      startEnd:[],
      end:'',
      radioOptions: [
        { label: '按年份', value: 'year' },
        { label: '按月份', value: 'month' },
        { label: '按日期', value: 'date' },
        { label: '按截止日期', value: 'end' }
      ]
    }
  },
  watch:{
    year:{
      handler(newVal,oldVal){
        if(newVal){
          if(this.radio === 'year'){
            const sendData = {
              title:this.option.find(item => item.value === this.timeName).label,
              key:this.timeName,
              value:this.returnTimeRange(newVal).join(',')
            }
            this.$emit('sendData',sendData)
          }
        } else if(oldVal && !newVal){
          this.$emit('sendData', {})
        }
      },
      immediate:true
    },
    month:{
      handler(newVal,oldVal){
        if(newVal){
          if(this.radio === 'month'){
            const sendData = {
              title:this.option.find(item => item.value === this.timeName).label,
              key:this.timeName,
              value:this.returnTimeRange(newVal).join(',')
            }
            this.$emit('sendData',sendData)
          }
        } else if(oldVal && !newVal){
          this.$emit('sendData', {})
        }
      },
      immediate:true
    },
    date:{
      handler(newVal,oldVal){
        if(Array.isArray(newVal) && newVal.length === 2){
          if(this.radio === 'date'){
            const sendData = {
              title:this.option.find(item => item.value === this.timeName).label,
              key:this.timeName,
              value:this.returnTimeRange(newVal).join(',')
            }
            this.$emit('sendData',sendData)
          }
        } else if(Array.isArray(oldVal) && oldVal.length === 2 && !(Array.isArray(newVal) && newVal.length === 2)){
          this.$emit('sendData', {})
        }
      },
      immediate:true
    },
    end: {
      handler(newVal, oldVal) {
        if (newVal) {
          if (this.radio === 'end') {
            const sendData = {
              title: this.option.find(item => item.value === this.timeName).label,
              key: this.timeName,
              value: this.returnTimeRange(['2025-01-01',newVal]).join(',')
            }
            this.$emit('sendData', sendData)
          }
        } else if (oldVal && !newVal) {
          this.$emit('sendData', {})
        }
      },
      immediate: true
    },
  },
  methods: {
    sendSearchData(){
      if((Array.isArray(this[this.radio]) && this[this.radio].length === 2) || (!Array.isArray(this[this.radio]) && this[this.radio])){
        const sendData = {
          title:this.option.find(item => item.value === this.timeName).label,
          key:this.timeName,
          value:this.returnTimeRange(this[this.radio]).join(',')
        }
        this.$emit('sendData',sendData)
      }else{
        this.$emit('sendData', {})
      }
    },
    combineTimeRanges(range1, range2) {
      if(!range1){
        return range2
      }
      if(!range2){
        return range1
      }
      // 获取两个范围的开始和结束时间
      const start1 = range1[0];
      const end1 = range1[1];
      const start2 = range2[0];
      const end2 = range2[1];
      // 比较开始时间，取较小的
      const minStart = start1 < start2 ? start1 : start2;
      // 比较结束时间，取较大的
      const maxEnd = end1 > end2 ? end1 : end2;
      return [minStart, maxEnd];
    },
    returnTimeRange(value) {
      let time = []
      if(Array.isArray(value)){
        time.push(this.getTimeRange(value[0]))
        time.push(this.getTimeRange(value[1]))
        return this.combineTimeRanges(time[0],time[1])
      } else {
        return this.getTimeRange(value)
      }
    },
    getTimeRange(input) {
      let start;
      let end;
      // 检查输入格式
      const parts = input.split('-');
      if (parts.length === 1) {
        // 输入为年份
        start = new Date(input, 0, 1, 0, 0, 0);
        end = new Date(input, 11, 31, 23, 59, 59);
      } else if (parts.length === 2) {
        // 输入为年份和月份
        const year = parseInt(parts[0]);
        const month = parseInt(parts[1]) - 1; // 月份从 0 开始
        start = new Date(year, month, 1, 0, 0, 0);
        end = new Date(year, month + 1, 0, 23, 59, 59);
      } else if (parts.length === 3) {
        // 输入为年份、月份和日期
        const year = parseInt(parts[0]);
        const month = parseInt(parts[1]) - 1; // 月份从 0 开始
        const day = parseInt(parts[2]);
        start = new Date(year, month, day, 0, 0, 0);
        end = new Date(year, month, day, 23, 59, 59);
      } else {
        throw new Error('输入格式不正确，请输入正确的年份、年份-月份或年份-月份-日期');
      }
      return [this.formatDate(start), this.formatDate(end)];
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    async exportToExcel(type){
      try{
        let data = {}
        switch (type) {
          case 'time':
            if (!this.timeName) {
              this.$messageUi.error('请选择导出时间类型')
              return
            }
            switch (this.radio) {
              case 'year':
                if (!this.year) {
                  this.$messageUi.error('请选择需导出的年份')
                  return
                }
                this.startEnd = this.returnTimeRange(this.year)
                break
              case 'month':
                if (!this.month) {
                  this.$messageUi.error('请选择需导出的月份')
                  return
                }
                this.startEnd = this.returnTimeRange(this.month)
                break
              case 'date':
                if (this.date.length < 2) {
                  this.$messageUi.error('请选择需导出的日期')
                  return
                }
                this.startEnd = this.returnTimeRange(this.date)
                break
              case 'end':
                if (!this.end) {
                  this.$messageUi.error('请选择截止日期')
                  return
                }
                this.startEnd = this.returnTimeRange(['2025-01-01', this.end])
                break
              default:
                break
            }
            data = { ...this.requestData }
            const key = 'query#' + this.timeName + '.BETWEEN'
            data[key] = this.startEnd.join(',')
            
            break
          case 'ids':
            if(this.ids.length === 0){
              this.$messageUi.error('请勾选需导出的数据信息')
              return
            }
            data['ids'] = this.ids
            break
          default:
            this.$messageUi.error('请选择导出方法')
            return
        }
        const response = await this.apiFunction(data)
        fileDownload(response.file, response.fileName)
      } catch (error) {
        console.log(error);
      }
    },
    async exportAllToExcel() {
      try {
        let data = {...this.requestData}
        const response = await this.apiFunction(data)
        fileDownload(response.file, response.fileName)
      } catch (error) {
        console.log(error);
      }
    }
  }
}
</script>

<style scoped>

</style>